<template>
  <div>
    <AlertMessage :show="hasUnselectedMeter"
                  :variant="BootstrapVariant.INFO"
                  :message="tr('administration.powerFlow.NO_METER_SELECTED_CONSUMPTION')"></AlertMessage>
    <BFormCheckbox v-model="consumptionIsInstalled"
                   name="consumption">
      {{ tr('administration.powerFlow.CONSUMPTION_DESCRIPTION') }}
    </BFormCheckbox>
    <template v-if="consumptionIsInstalled && meters.length > 0">
      <BFormCheckbox v-model="meterIsInstalled"
                     name="meter"
                     class="mt-2">
        {{ tr('administration.powerFlow.METER_DESCRIPTION') }}
        <InfoIconWithTooltip>
          <p @click="onMeasurementOverviewDescriptionClicked"
             v-html="tr('administration.powerFlow.GRID_TOOLTIP',[`class='clickable link'`])"></p>
        </InfoIconWithTooltip>
      </BFormCheckbox>
      <BFormGroup v-if="meterIsInstalled"
                  :content-cols="4"
                  :label="tr('common.METER_SINGULAR')"
                  :label-cols="2"
                  label-for="measurements-selection"
                  class="mt-3 ml-3">
        <Selection id="measurements-selection"
                   v-model="consumption"
                   :label-cols="5"
                   :options="meters"
                   :close-on-select="true"
                   :preserve-search="true"
                   :custom-label="makeOptionLabel"
                   track-by="abbreviation">
          <template #option="{ option }">
            <span class="text-truncate"
                  :title="makeOptionLabel(option)">{{ makeOptionLabel(option) }}</span>
          </template>
        </Selection>
      </BFormGroup>
    </template>
  </div>
</template>

<script>
  import { BFormGroup, BFormCheckbox } from 'bootstrap-vue';
  import Abbreviation from '@common/const/Abbreviation';
  import Selection from '../../../../common/selection/Selection.vue';
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import InfoIconWithTooltip from '../../../../common/layout/InfoIconWithTooltip.vue';
  import AlertMessage from '../../../../common/layout/AlertMessage.vue';

  export default {
    name: 'ConsumptionConfig',
    compatConfig: {
      MODE: 3,
    },
    components: {
      InfoIconWithTooltip,
      AlertMessage,
      Selection,
      BFormGroup,
      BFormCheckbox,
    },
    mixins: [
      translator,
    ],
    inject: [
      'onMeasurementOverviewDescriptionClicked',
    ],
    props: {
      consumptionConfig: {
        type: Object,
      },
      makeOptionLabel: {
        type: Function,
        required: true,
      },
      metersGroupedByAbbreviation: {
        type: Object,
        required: true,
      },
    },
    emits: ['consumption-changed'],
    data() {
      return {
        BootstrapVariant,
        consumption: null,
        consumptionIsInstalled: false,
        meterIsInstalled: false,
      };
    },
    computed: {
      meters() {
        return this.metersGroupedByAbbreviation[Abbreviation.ENERGY_INTERVAL_EXPORT]
          .concat(this.metersGroupedByAbbreviation[Abbreviation.ENERGY_INTERVAL]);
      },
      hasUnselectedMeter() {
        return this.consumptionIsInstalled && !this.meterIsInstalled;
      },
    },
    watch: {
      consumption() {
        this.onDataChanged();
      },
      consumptionIsInstalled() {
        this.onDataChanged();
      },
      meterIsInstalled() {
        this.onDataChanged();
      },
    },
    mounted() {
      this.resetConsumption();
    },
    methods: {
      onDataChanged() {
        if (this.consumptionIsInstalled) {
          this.$emit(
            'consumption-changed',
            {
              consumptionIsInstalled: this.consumptionIsInstalled,
              meterId: this.meterIsInstalled ? this.consumption?.id : null,
            },
          );
        } else {
          this.$emit('consumption-changed', null);
        }
      },
      resetConsumption() {
        if (this.consumptionConfig) {
          this.consumptionIsInstalled = this.consumptionConfig.consumptionIsInstalled;
          this.meterIsInstalled = !!this.consumptionConfig.meterId;
        }
        if (this.meterIsInstalled) {
          this.consumption = this.meters.find((meter) => meter.id === this.consumptionConfig.meterId);
        } else {
          this.consumption = this.meters[0] ?? null;
        }
      },
    },
  };
</script>
